import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent} from './login/login.component';
import { CAPDAdminComponent } from './capd-admin-component/capd-admin.component';

import { MModalManagerComponent } from './mmodal-manager/mmodal-manager.component';
import { ClientManagerComponent } from './client-manager/client-manager.component';

import { LibraryComponent } from './rule/rule.component';
import { PackageComponent } from './package/package.component';

import { SettingsComponent } from './settings/settings.component';
import { UserComponent } from './users/user.component';
import { CompanyContentComponent } from './company/company.component';
import { TenantMappingsComponent } from './cds_tenant_mapping/tenant_mappings_org.component';
import { TenantMappingsRootComponent } from './cds_tenant_mapping/tenant_mappings_root.component';
import { GroupContentComponent } from './group/group.component';

import {CapdClientMock} from "./capd-client-mock/capd-client-mock.component";
import {LibraryComponentV2} from "./rule/v2/library.component";
import {CompanyContentComponentV2} from "./company/v2/company.component";
import {GroupContentComponentV2} from "./group/v2/group.component";
import {SsoLoginComponent} from './login/sso-login.component';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  // Default page: auto directs to login, but can go to main
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  // {
    // path: 'logout',
    // redirectTo: '/login',
    // pathMatch: 'full'
  // },
  // Login
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'SsoLogin/:accessToken',
    component: SsoLoginComponent,
    data: {
      shouldReuse: false
    }
  },
  // Main app
  {
    path: 'main',
    component: CAPDAdminComponent,
    canActivate: [AuthGuardService],
    children: [
      // Internal M*Modal library
      {
        path: 'mmodal',
        component: MModalManagerComponent,
        children: [
          // Default: Rules library
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'library'
          },
          // Rules library page
          {
            path: 'library',
            component: LibraryComponent
          },
          // Package library page
          {
            path: 'packages',
            component: PackageComponent
          },
          {
            path: 'root-tenant-mapping',
            component: TenantMappingsRootComponent
          },
          {
            path: 'v2',
            children: [
              {
                path: 'library',
                component: LibraryComponentV2
              }
            ]
          }
        ]
      },
      // Company page
      {
        path: 'company',
        component: ClientManagerComponent,
        children: [
          {
            path: ':id',
            children: [
              // Default: the company's settings page
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'settings'
              },
              // Settings page V2
              {
                path: 'settings/v2',
                component: SettingsComponent
              },
              // Settings page
              {
                path: 'settings',
                component: SettingsComponent
              },
              // List of users
              {
                path: 'users',
                component: UserComponent
              },
              // Company-level content page
              {
                path: 'content/v2',
                component: CompanyContentComponentV2
              },
              {
                path: 'content',
                component: CompanyContentComponent,
              },
              // User group-level content page
              {
                path: 'grouprules',
                component: GroupContentComponent
              },
              {
                path: 'grouprules/v2',
                component: GroupContentComponentV2
              },
              // Tenant Mapping adjustments
              {
                path: 'tenant-mappings',
                component: TenantMappingsComponent
              },
              {
                path: 'capd-client-mock',
                component: CapdClientMock
              }
            ]
          }
        ]
      }
    ]
  }
];

export const appRouterProviders = [];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
